/**
 * Utility functions for WhatsApp message handling
 */

/**
 * Open WhatsApp with a message
 * @param {String} message - The message to send
 * @param {String} phoneNumber - Optional phone number
 * @returns {Promise<void>}
 */
export function openWhatsApp(message, phoneNumber = '') {
  const encodedMessage = encodeURIComponent(message)
  
  // Always use wa.me/?text= format to open WhatsApp Web/app directly
  let whatsappUrl = `https://wa.me/?text=${encodedMessage}`
  
  // If phone number is provided, append it to the URL
  if (phoneNumber && phoneNumber.trim()) {
    const formattedNumber = phoneNumber.trim().replace(/[+\s-]/g, '')
    whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodedMessage}`
  }
  
  try {
    const newWindow = window.open(whatsappUrl, '_blank')
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      window.location.href = whatsappUrl
    }
  } catch (error) {
    console.error('Error opening WhatsApp:', error)
    window.location.href = whatsappUrl
  }
}

